export const TAB_INDICES = {
  MAIL_PREVIEW: 0,
  DEMONSTRATION_AGENDA: 1,
  DECISION: 2,
} as const;
